// extracted by mini-css-extract-plugin
export var numpadContainer = "_ng-1";
export var phoneButton = "_ng-0";